import React from 'react';
import { ZoneProvider } from './context/index';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import AppRouter from './router';
import { persistor, store } from './store';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
const theme = createTheme({
  typography: {
    fontFamily: ['canalfont-regular', 'canalfont-bold', 'canalfont-italique'].join(','),
  },
});
function App() {
  console.log(`Environment: ${window._env_?.REACT_APP_ENVIRONMENT}`);
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ZoneProvider>
            <AppRouter />
          </ZoneProvider>
        </PersistGate>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
